<template>
  <div class="home py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.aerators.createBootloader")}}</span>
    <div v-if="dataLoaded" class="form-container">
      <AveineAeratorVersionForm :APIbaseURL="APIbaseURL" :version="version" versionType="bootloader" :hardwareVersions="hardwareVersions" :existingDfuPackages="existingDfuPackages" :adminMode="true"/>
    </div>
    <div v-else class="d-flex justify-center align-center mt-16">
      <v-progress-circular
        indeterminate
        :size="100"
        :width="10"
        color="secondary"
      ></v-progress-circular>
    </div>
  </div>
</template>

<script>
import { AveineAeratorVersionForm } from 'aveine-aerator'
import { DfuPackage, HardwareVersion, BootloaderVersion } from 'aveine-toolbox'
export default {
  data () {
    return {
      version: {},
      dfuPackage: {},
      hardwareVersions: [],
      existingDfuPackages: [],
      dataLoaded: false,
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  name: 'Create',
  components: {
    AveineAeratorVersionForm
  },
  async created() {
    this.version = await BootloaderVersion.new();

    let reqDfu = await DfuPackage.insert({
      data: {
        $isNew: true,
        bootloader: true,
        description: {fr:""}
      }
    })

    this.version.dfu_package = await DfuPackage.query().whereId(reqDfu.dfu_packages[0].id).withAllRecursive().first();

    const that = this
    let reqHarwareVersion = await HardwareVersion.api().get(`hardware-versions`);
    reqHarwareVersion.response.data.map(async function(data){
      const hardware = await HardwareVersion.query().whereId(data.id).withAllRecursive().first();
      that.hardwareVersions.push({label: `${hardware.model}/${hardware.version}`, value: hardware});
    })

    let reqExistingDfu = await DfuPackage.api().get(`dfu-packages`, {
      params: {
        include: "target-hardware"
      }
    })
      
    reqExistingDfu.response.data.map(async function(data){
      const dfu = await DfuPackage.query().whereId(data.id).withAllRecursive().first();
      that.existingDfuPackages.push({label: `${dfu.name}`, value: dfu});
    })

    this.version.$isNew = true;
    this.dataLoaded = true;
  },
}
</script>
